import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Podcast as Desc } from './desk'
import { Podcast as Mob } from './mob'

type Props = {
  images: TImages
}
export const Podcast: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
